import { itixShowController } from '@x-com/pwitixcomm/tslib/itix.show.ts'

const applyStatus = (el: Element, status: string) => {
    const span = el.querySelector('span')
    const icon = el.querySelector('i')
    let buttonclass = 'btn--cart'
    let showicon = 'fa-cart-shopping'

    if (
        status === 'uitverkocht' ||
        status === 'geannuleerd' ||
        status === 'geweest' ||
        status === 'geen_webverkoop' ||
        status === ''
    ) {
        buttonclass = `btn--cart-disabled`
        showicon = 'fa-cart-circle-xmark'
    } else if (status === 'wachtlijst') {
        buttonclass = `btn--cart-waitinglist`
        showicon = 'fa-hourglass-half'
    }

    if (span && icon && window.orderTranslations[status] !== undefined) {
        el.classList.remove('hide')
        el.classList.remove('btn--cart')
        el.classList.add(buttonclass)
        span.innerHTML = window.orderTranslations[status]
        icon.classList.remove('fa-cart-shopping')
        icon.classList.add(showicon)
        if (
            status === 'uitverkocht' ||
            status === 'geannuleerd' ||
            status === 'geweest' ||
            status === 'geen_webverkoop' ||
            status === ''
        ) {
            el.setAttribute('disabled', '')
        }
    }
}

export const initShowStatus = async () => {
    const allShowEls = Array.from(document.querySelectorAll('[data-showid]'))

    // Handle elements with a pre-known series status — no API call needed
    const overrideEls = allShowEls.filter((el) => (el as HTMLElement).dataset.seriesstatus !== undefined)
    overrideEls.forEach((el) => {
        applyStatus(el, (el as HTMLElement).dataset.seriesstatus!)
    })

    const showIds: string[] = Array.from(
        new Set(
            allShowEls
                .filter((el) => (el as HTMLElement).dataset.seriesstatus === undefined)
                .map((el) => (el as HTMLElement).dataset.showid)
        )
    )

    if (showIds.length > 0) {
        const formData = new FormData()

        showIds.forEach((showId) => {
            formData.append('show_ids[]', showId)
        })

        const data = await itixShowController.getStatus(formData)

        if (data.status === 'OK') {
            Object.entries(data.message.shows)?.forEach(([showId, showData]) => {
                document.querySelectorAll(`[data-showid="${showId}"]`).forEach((el) => {
                    if (el) {
                        applyStatus(el, showData.status)
                    }
                })
            })
        }
    }
}
